import { createSlice } from '@reduxjs/toolkit';
import {
  ExternalUserReportsState,
  ExternalUserReportListFetchAction,
  ExternalUserReportListFetchSuccessAction,
  UploadExternalUserReportAction,
  UploadExternalUserReportSuccessAction,
  DownloadExternalUserReportsAction,
} from './ExternalUserReports.types';
import { createSelector, createSliceHook, makeActionCreator } from '../helpers';

const initialState: ExternalUserReportsState = {
  uploadedReports: [],
  uploads: [],
  loading: false,
  error: undefined,
};

const { actReject, actReq, actResolve, act } =
  makeActionCreator<ExternalUserReportsState>();

export const ExternalUserReportsSlice = createSlice({
  name: 'ExternalUserReports',
  initialState,
  reducers: {
    fetchExternalUserReportList: actReq<ExternalUserReportListFetchAction['payload']>(),
    fetchExternalUserReportListSuccess:
      actResolve<ExternalUserReportListFetchSuccessAction['payload']>('uploadedReports'),
    fetchExternalUserReportListFailure: actReject(),

    uploadExternalUserReport: actReq<UploadExternalUserReportAction['payload']>(),
    uploadExternalUserReportSuccess: actResolve<UploadExternalUserReportSuccessAction['payload']>('uploads'),
    uploadExternalUserReportFailure: actReject(),

    downloadExternalUserReports: act<DownloadExternalUserReportsAction['payload']>(() => ({})),
  },
});

export const {
  fetchExternalUserReportList,
  fetchExternalUserReportListSuccess,
  fetchExternalUserReportListFailure,
  uploadExternalUserReport,
  uploadExternalUserReportSuccess,
  uploadExternalUserReportFailure,
  downloadExternalUserReports,
} = ExternalUserReportsSlice.actions;

export const actions = {
  ...ExternalUserReportsSlice.actions,
};

export const useExternalUserReportsSlice = createSliceHook(
  ExternalUserReportsSlice.name,
  actions
);

export const selectExternalUserReportsState = createSelector(ExternalUserReportsSlice.name);
